
namespace Matrix.Workflow {

    @Serenity.Decorators.registerEditor()
    export class ClientFunctionTriggerTypeEditor extends Serenity.Select2Editor<any, any> {

        constructor(element: JQuery) {
            super(element);

            this.addOption("blob_storage", "BLOB Storage");
            this.addOption("manual", "Manual Trigger");
            this.addOption("service_bus", "Service Bus");
            this.addOption("timer", "Timer");
        }
    }
}